import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";

export function useTotalMensagemNaoRespondida(
  {
    tenantsIds,
  }: {
    tenantsIds?: string[];
  },
  enabled = true
) {
  return useQuery<{ total: number }, AxiosError>(
    [`/v1/mensagem/total-nao-respondida`, tenantsIds],
    async () => {
      const { data } = await http.get<{ total: number }>(
        "/v1/mensagem/total-nao-respondida",
        {
          params: {
            tenantsIds,
          },
        }
      );

      return data;
    },
    {
      enabled,
    }
  );
}
